<template>
  <button class="line_button" @click.prevent="moveToLine">
    <img src="/img/line_icon.png" class="line_icon" />
    <p :class="lineTextClass">
      {{ $t('order_details__button__add_line_friend') }}
    </p>
  </button>
</template>

<script lang="ts">
import 'vue-i18n'
import { Vue, Component } from 'vue-property-decorator'

@Component
export default class LineButton extends Vue {
  moveToLine() {
    // LINE側のページに遷移
    location.href = 'https://page.line.me/reality_official'
    return
  }

  get lineTextClass() {
    return 'line_text -' + this.$i18n.locale
  }
}
</script>

<style scoped>
.line_button {
  width: 100%;
  height: 48px;
  padding: 8px 8px;
  border-radius: 24px;
  color: #ffffff;
  cursor: pointer;
  border: none;
  background-color: #06c755;
}

.line_icon {
  width: 32px;
  height: 32px;
}

.line_text {
  width: auto;
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: 0.5px;
  text-align: center;
  padding-left: 10px;
}

/* latin alphabet style */
.line_text.-en,
.line_text.-es,
.line_text.-pt-BR,
.line_text.-id,
.line_text.-fr,
.line_text.-ru,
.line_text.-de,
.line_text.-ms {
  font-size: 10px;
  letter-spacing: inherit;
}
</style>
